var vehicle={};

function vehicleColors(data) {
    var extColor = $('.swatch-outer.selected').data(),
        intColor = $('.swatch-inner.selected').data();
    var extAPIColors = [];

    vehicle.extColor = extColor ? findExtColor(extColor.colorName) : '';
    vehicle.intColor = intColor ? findIntColor(intColor.colorName) : '';
    matchExtColors();

    function findExtColor(colorName) {
        var colorCode;
        data.colors.forEach(function (option) {
            if(option.category == 'Exterior') {
                var extColorArray = option.options;
                extColorArray.forEach(function (color) {
                    if(color.name == colorName) {
                        colorCode = color.manufactureOptionCode;
                    }
                    extAPIColors.push(color.name);
                });
            }
        });
        return colorCode || '';
    }
    function findIntColor(colorName) {
        var colorCode;
        data.colors.forEach(function (option) {
            if(option.category == 'Interior') {
                var extColorArray = option.options;
                extColorArray.forEach(function (color) {
                    if(color.name == colorName) {
                        colorCode = color.manufactureOptionCode;
                    }
                });
            }
        });
        return colorCode || '';
    }
    function matchExtColors() {
        var extColors = window.EDM.PageValues.vehicle.colors || [];
        
        extColors.filter(function (option, index) {
            if(option.color.type == 'EXTERIOR') {
                if(extAPIColors.indexOf(option.color.name) == -1) {
                    $('.swatch-outer').eq(index+1).addClass('hidden');
                } 
            } 
        });
    }
}
module.exports = {
    vehicleColors: vehicleColors,
    vehicle: vehicle
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/build/find-colors.js
// module id = 183
// module chunks = 0 1 23